export function parseValorMonetario(valor: unknown): number | null {
  if (valor == null || valor === '') {
    return null;
  }
  if (typeof valor === 'number' && Number.isFinite(valor)) {
    return valor;
  }
  const texto = String(valor).trim();
  if (!texto) {
    return null;
  }
  const normalizado = texto
    .replace(/R\$\s?/gi, '')
    .replace(/\s/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const n = parseFloat(normalizado);
  return Number.isFinite(n) ? n : null;
}

export function isContaFinanceiraAberta(situacao: unknown, situacaoAberta: string): boolean {
  const s = String(situacao ?? '').toUpperCase().replace(/\s/g, '_');
  if (!s) {
    return true;
  }
  if (s === situacaoAberta.toUpperCase()) {
    return true;
  }
  return s !== 'RECEBIDO' && s !== 'PAGO';
}
